import { render, staticRenderFns } from "./MessagesArchive.vue?vue&type=template&id=06835b76&"
import script from "./MessagesArchive.vue?vue&type=script&lang=js&"
export * from "./MessagesArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports